const NOTIFICATION_URLS = {
  EXERCISE_SUBMITTED: `timeline`,
  EXERCISE_COMMENTED: `exercises`,
  ESSAY_UNIVERSITY_ADD: `essays`,
  ESSAY_STATUS_UPDATE_HC_REVIEW: `essays`,
  STUDENT_ESSAY_STATUS_CHANGED_DRAFT: `essays`,
  ESSAY_STATUS_UPDATED_DONE: `essays`,
  ESSAY_CREATE: `essays`,
  SCHOOL_STATUS_UPDATE: `schools`,
  STUDENT_INACTIVE: `timeline`,
  PERSONAL_STATEMENT_ADDED: `common-app/statements`,
  STUDENT_PERSONAL_STATEMENT_STATUS_CHANGED_DRAFT: `common-app/statements`,
  OTHER_PERSONAL_STATEMENT_STATUS_CHANGED_DRAFT: `common-app/statements`,
  PERSONAL_STATEMENT_STATUS_CHANGED_CC_REVIEW: `common-app/statements`,
  PERSONAL_STATEMENT_STATUS_CHANGED_HC_REVIEW: `common-app/statements`,
  PERSONAL_STATEMENT_STATUS_CHANGED_DONE: `common-app/statements`,
  STUDENT_PROFILE_COMPLETED: `profile`,
  CONVO_ADMIN_REMINDER: 'convo/'
};

export default NOTIFICATION_URLS;

export const EVENT_TRIGGERS = [
  {
    label: 'CC Meeting',
    options: [
      { label: 'Scheduled', value: 'COACHING_SCHEDULED' },
      { label: 'Rescheduled', value: 'COACHING_RESCHEDULED' },
      { label: 'Canceled', value: 'COACHING_CANCELLED' },
      { label: 'Done', value: 'COACHING_DONE' },
      { label: 'No Show', value: 'COACHING_NOSHOW' },
      { label: 'Meeting Reminder', value: 'CC_MEETING_REMINDER' },
    ]
  },
  {
    label: 'HC Meeting',
    options: [
      { label: 'Scheduled', value: 'MILESTONE_MEETING_SCHEDULED' },
      { label: 'Rescheduled', value: 'MILESTONE_MEETING_RESCHEDULED' },
      { label: 'Canceled', value: 'MILESTONE_MEETING_CANCELLED' },
      { label: 'Done', value: 'MILESTONE_MEETING_DONE' },
      { label: 'No Show', value: 'MEETING_NOSHOW' },
      { label: 'Meeting Reminder', value: 'HC_MEETING_REMINDER' },
    ]
  },
  {
    label: 'FA Meeting',
    options: [
      { label: 'Scheduled', value: 'FA_MEETING_SCHEDULED' },
      { label: 'Rescheduled', value: 'FA_MEETING_RESCHEDULED' },
      { label: 'Canceled', value: 'FA_MEETING_CANCELLED' },
      { label: 'Done', value: 'FA_MEETING_DONE' },
      { label: 'No Show', value: 'FA_MEETING_NOSHOW' },
      { label: 'Meeting Reminder', value: 'FA_MEETING_REMINDER' },
    ]
  },
  {
    label: 'Worksheet',
    options: [
      { label: 'Done', value: 'EXERCISE_SUBMITTED' },
      { label: 'Commented', value: 'EXERCISE_COMMENTED' },
    ]
  },
  {
    label: 'Milestone',
    options: [
      { label: 'Done', value: 'MILESTONE_DONE' },
    ]
  },
  {
    label: 'Essay',
    options: [
      { label: 'University Added', value: 'UNIVERSITY_ADD' },
      { label: 'Essay Created', value: 'ESSAY_CREATE' },
      { label: 'Student - changed to Draft', value: 'STUDENT_ESSAY_STATUS_CHANGED_DRAFT' },
      { label: 'Coaches - changed to Draft', value: 'OTHER_ESSAY_STATUS_CHANGED_DRAFT' },
      { label: 'Coaches - changed Draft due date', value: 'OTHER_ESSAY_STATUS_CHANGED_DRAFT_WITH_DUE_DATE' },
      { label: 'Changed to CC Review', value: 'ESSAY_STATUS_UPDATE_CC_REVIEW' },
      { label: 'Changed to HC Review', value: 'ESSAY_STATUS_UPDATE_HC_REVIEW' },
      { label: 'Changed to HC Done', value: 'ESSAY_STATUS_UPDATED_DONE' },
      { label: 'Changed to Expert Review', value: 'ESSAY_STATUS_UPDATE_EXPERT_REVIEW' },
    ]
  },
  {
    label: 'College',
    options: [
      { label: 'Application status changed', value: 'SCHOOL_STATUS_UPDATE' },
    ]
  },
  {
    label: 'Personal Statements',
    options: [
      { label: 'Added', value: 'PERSONAL_STATEMENT_ADDED' },
      { label: 'Student - changed to Draft', value: 'STUDENT_PERSONAL_STATEMENT_STATUS_CHANGED_DRAFT' },
      { label: 'Coaches - changed to Draft', value: 'OTHER_PERSONAL_STATEMENT_STATUS_CHANGED_DRAFT' },
      { label: 'Coaches - changed Draft due date', value: 'OTHER_PERSONAL_STATEMENT_STATUS_CHANGED_DRAFT_WITH_DUE_DATE' },
      { label: 'Changed to CC Review', value: 'PERSONAL_STATEMENT_STATUS_CHANGED_CC_REVIEW' },
      { label: 'Changed to HC Review', value: 'PERSONAL_STATEMENT_STATUS_CHANGED_HC_REVIEW' },
      { label: 'Changed to HC Done', value: 'PERSONAL_STATEMENT_STATUS_CHANGED_DONE' },
      { label: 'Changed to Expert Review', value: 'PERSONAL_STATEMENT_STATUS_CHANGED_EXPERT_REVIEW' },
    ]
  },
  {
    label: 'Student Profile',
    options: [
      { label: 'Student profile completed', value: 'STUDENT_PROFILE_COMPLETED' },
      { label: 'Student profile incomplete', value: 'STUDENT_PROFILE_INCOMPLETE' },
    ]
  },
  {
    label: 'Others',
    options: [
      { label: 'Student inactive for 2 weeks', value: 'STUDENT_INACTIVE' },
      { label: 'Meeting status change reminder', value: 'MEETING_STATUS_REMINDER' },
      { label: 'Message reply reminder', value: 'CHAT_MESSAGE_REPLY_REMINDER' },
      { label: 'Essay HC review reminder', value: 'HC_REVIEW_REMINDER' },
      { label: 'Essay CC review reminder', value: 'CC_REVIEW_REMINDER' },
      { label: 'Personal Statement HC review reminder', value: 'PERSONAL_STATEMENT_HCREVIEW_REMINDER' },
      { label: 'Personal Statement CC review reminder', value: 'PERSONAL_STATEMENT_CCREVIEW_REMINDER' },
      { label: 'Milestone Status reminder', value: 'MILESTONE_DONE_REMINDER' },
      { label: 'Check Progress of student - 10days', value: 'CHECK_PROGRESS_REMINDER_10' },
      { label: 'Check Progress of student - 60days', value: 'CHECK_PROGRESS_REMINDER_60' },
      { label: 'Check Progress of student - 120days', value: 'CHECK_PROGRESS_REMINDER_120' },
      { label: 'No Message sent or received', value: 'NO_MESSAGE_REMINDER' },
      { label: 'HC assigned', value: 'HC_UPDATED' },
      { label: 'CC assigned', value: 'LC_UPDATED' },
      { label: 'FC assigned', value: 'FA_UPDATED' },
      { label: 'HC and CC assigned', value:'LC_HC_UPDATED' },
      { label: 'HC and CC and FC assigned', value: 'LC_HC_FA_UPDATED' },
      { label: 'First Meeting Done', value: 'FIRST_MEETING_DONE' },
      { label: 'MBG Reminder', value: 'MBG_REMINDER' },
      { label: 'Application Deadline Due in 1 day', value: 'APPLICATION_DEADLINE_REMINDER_1' },
      { label: 'Application Deadline Due in 7 days', value: 'APPLICATION_DEADLINE_REMINDER_7' },
    ]
  }
];

export const MESSAGE_VARIABLES = {
  '{{recipient_first_name}}': 'Recipient first name',
  '{{student.name}}': 'Student preferred/first name',
  '{{student.user_first_name}}': 'Student first name',
  '{{student.user_last_name}}': 'Student last name',
  '{{lc.user_first_name}}': 'CC first name',
  '{{lc.user_last_name}}': 'CC last name',
  '{{lc_profile.bio}}': 'CC Bio',
  '{{hc.user_first_name}}': 'HC first name',
  '{{hc.user_last_name}}': 'HC last name',
  '{{hc_profile.bio}}': 'HC Bio',
  '{{fa.user_first_name}}': 'FA first name',
  '{{fa.user_last_name}}': 'FA last name',
  '{{fc_profile.bio}}': 'FA Bio',
  '{{parent.0.user_first_name}}': 'Parent 1 first name',
  '{{parent.0.user_last_name}}': 'Parent 1 last name',
  '{{parent.1.user_first_name}}': 'Parent 2 first name',
  '{{parent.1.user_last_name}}': 'Parent 2 last name',
  '{{date}}': 'Date',
  '{{date_time}}': 'Date & time',
  '{{exercise_name}}': 'Exercise name',
  '{{module_name}}': 'Module name',
  '{{milestone_name}}': 'Milestone name',
  '{{milestone_next}}': 'Next Milestone',
  '{{exercises_next}}': 'Next Exercises',
  '{{milestone_feedback}}': 'Milestone feedback',
  '{{meeting_summary}}': 'Meeting summary',
  '{{university_name}}': 'College name',
  '{{essay_name}}': 'Essay name',
  '{{statement_name}}': 'Personal statement name',
  '{{document_name}}': 'Essay document name',
  '{{status}}': 'Status (Essay, College etc)',
  '{{senderFullName}}': 'Message Sender Name',
  '{{student.product_type}}': 'Product Type',
  '{{student.graduation_year}}': 'Graduation year',
  '{{both_parents_first_name}}': 'Both parents first name',
  '{{application_deadline}}': 'Application Deadline'
}